import { forwardRef, useCallback, useRef } from 'react';
import BaseWebEditUniversal, { BaseWebEditUniversalProps } from '../../utilsTsx/components/system/BaseWebEditUniversal'
import { getService, ServiceIdType } from './WebUniversal';

/** WebEditUniversal属性 */
export interface WebEditUniversalProps extends Omit<BaseWebEditUniversalProps, 'defaultService'> {
    /** 后台服务数据 */
    serviceId?: ServiceIdType;
};

/**
 * 组件 WebEditUniversal
 */
const WebEditUniversal = forwardRef<any, WebEditUniversalProps>((props, ref) => {
    const refLocal = useRef<any>(undefined);
    /** 合并外部 ref 和内部 refLocal */
    const mergedRef = useCallback(
        (node: any) => {
            refLocal.current = node;
            if (typeof ref === 'function') {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
        },
        [ref],
    );
    const { serviceId } = props;
    const currentProps: BaseWebEditUniversalProps = {
        ...props,
        defaultService: getService(serviceId)
    }
    return <BaseWebEditUniversal ref={mergedRef} {...currentProps} />;
});

export default WebEditUniversal;